export default __webpack_public_path__ + "static/media/logo_login.9f113408.svg";